var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9167 25C44.9167 13.73 35.77 4.58331 24.5 4.58331C13.23 4.58331 4.08337 13.73 4.08337 25C4.08337 36.27 13.23 45.4166 24.5 45.4166",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3334 6.625H18.3751C14.3938 18.5483 14.3938 31.4517 18.3751 43.375H16.3334",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.625 6.625C32.6054 12.5867 33.6058 18.7933 33.6058 25",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 33.1667V31.125C12.0867 33.1054 18.2933 34.1059 24.5 34.1059",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 18.875C18.0483 14.8937 30.9517 14.8937 42.875 18.875",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8247 37.2501C36.7812 37.2438 36.7251 37.2438 36.6753 37.2501C35.5798 37.2127 34.7084 36.315 34.7084 35.2115C34.7084 34.0832 35.6172 33.1667 36.75 33.1667C37.8767 33.1667 38.7917 34.0832 38.7917 35.2115C38.7855 36.315 37.9203 37.2127 36.8247 37.2501Z",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.875 42.9723C41.2574 44.4931 39.1128 45.4167 36.75 45.4167C34.3872 45.4167 32.2426 44.4931 30.625 42.9723C30.7159 42.0953 31.2611 41.237 32.2335 40.5653C34.7235 38.8672 38.7947 38.8672 41.2665 40.5653C42.2389 41.237 42.7841 42.0953 42.875 42.9723Z",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 45.4167C41.2604 45.4167 44.9167 41.7604 44.9167 37.25C44.9167 32.7397 41.2604 29.0834 36.75 29.0834C32.2397 29.0834 28.5834 32.7397 28.5834 37.25C28.5834 41.7604 32.2397 45.4167 36.75 45.4167Z",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalSearch);
export default __webpack_public_path__ + "static/media/global-search.cdbdd6e264ea7f14b3fe3b914275abb7.svg";
export { ForwardRef as ReactComponent };